import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { NbAuthService } from "@nebular/auth";
import { NbAccessChecker } from "@nebular/security";
import { Observable, of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: NbAuthService,
    private router: Router,
    private accessChecker: NbAccessChecker
  ) {}

  /* canActivate() {
    return this.authService.isAuthenticated().pipe(
      tap((authenticated) => {
        if (!authenticated) {
          this.router.navigate(["auth/login"]);
        }
      })
    );
  } */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(
      switchMap((authenticated) => {
        if (!authenticated) {
          this.router.navigate(["/auth/login"]);
          return Observable.of(false);
        }
        // check app.routing module to understand the code
        const permission = route.data.permission; // Define the required permission in the route's data property
        if (permission) {
          return this.accessChecker.isGranted(permission[0], permission[1]);
        }
        return of(true);
      }),
      tap((isGranted) => {
        if (!isGranted) {
          this.router.navigate(["/access-denied"]); // Redirect to access-denied page if permission is not granted
        }
      })
    );
  }
}
